class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
  
        fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('product-recommendations');

                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.innerHTML = recommendations.innerHTML;
                }

                if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                    this.remove();
                }

                if (html.querySelector('.grid__item')) {
                    this.classList.add('product-recommendations--loaded');
                }
                if (this.dataset.slider) {
                    this.initSlider(this);
                }

            })
            .catch((e) => {
            console.error(e);
            });

    }

    initSlider(self) {
        new Swiper(`.${this.className.split(' ')[0]} .swiper`, {
        slidesPerView: 1.3,
        spaceBetween: 10,
        slidesOffsetBefore: 15,
          grabCursor: true,
          spaceBetween: 15,
          mousewheel: {
              forceToAxis: true,
          },
          navigation: {
            nextEl: `.${this.className.split(' ')[0]} .swiper-button-next`,
            prevEl: `.${this.className.split(' ')[0]} .swiper-button-prev`,
          },
          breakpoints: {
            768: {
                slidesOffsetBefore: 30,
                spaceBetween: 20,
            }
          }
      });
    
      }

  }
  
  customElements.define('product-recommendations', ProductRecommendations);